import {
  IPerformanceCustomerCenterOverview,
  IPerformancePagination,
  ICustomerRelationship,
  IMemberRelationship,
  IPerformanceTransactionData,
  ETransactionActionManager,
  IPerformanceTransactionDetailData
} from '@/models/performance';

import APIService from '.';
import { Pagination } from '@/models/general';
import { AxiosResponse } from 'axios';

export default class PerformanceCustomersService extends APIService {
  getOverview() {
    return this.get<IPerformanceCustomerCenterOverview>(
      '/v2/admin/customer/overview'
    );
  }

  getCustomerRelationshipsList(
    resource: string,
    params: Record<string, any> = {}
  ) {
    return this.get<IPerformancePagination<ICustomerRelationship>>(resource, {
      params
    });
  }

  getMemberRelationshipsList(
    resource: string,
    params: Record<string, any> = {}
  ) {
    return this.get<IPerformancePagination<IMemberRelationship>>(resource, {
      params
    });
  }

  listTransactions(
    resource: string,
    params: Record<string, any> = {}
  ): Promise<AxiosResponse<Pagination<IPerformanceTransactionData>>> {
    return this.get<Pagination<IPerformanceTransactionData>>(resource, {
      params
    });
  }

  detailTransaction(connectTransactionId: string) {
    return this.get<IPerformanceTransactionDetailData>(
      `/admin/lambda-webhooks/transaction/${connectTransactionId}`
    );
  }

  confirmPayment(id: string) {
    return this.put(
      `/admin/lambda-webhooks/transaction/${id}/${
        ETransactionActionManager.CLEAR
      }`
    );
  }

  cancelTransaction(id: string) {
    return this.put(
      `/admin/lambda-webhooks/transaction/${id}/${
        ETransactionActionManager.REFUND
      }`
    );
  }
}
